'use client';

import { useParams } from 'next/navigation';
import { useEffect } from 'react';
import { RETURN_GO_SHOP_NAME } from 'src/envVariables';

export const ReturnGo = () => {
  const { locale } = useParams();

  useEffect(() => {
    if (!window) {
      return;
    }

    /** need to connect script in this way, not through Script tag
     *  necessary for ReturnGo reopening
     */
    const script = document.createElement('script');
    script.src =
      'https://static.returngo.ai/master.returngo.ai/returngo.min.js';
    script.async = true;
    window.returnGoCanBeRun = true;
    document.body.appendChild(script);
    window.returnGoCanBeRun = true;
    window.ReturnGO = {
      shop: RETURN_GO_SHOP_NAME,
      locale,
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [locale]);

  return (
    <div
      id="ReturngoPortalEmbedding"
      style={{
        position: 'relative',
        display: 'block',
        minHeight: '300px',
      }}
    />
  );
};
